// client/src/components/logistics/AddMaterialModal.js
import React, { useState } from 'react';
import './AddMaterialModal.css'; // Nayi unique CSS file

const AddMaterialModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({});
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="amm-modal-overlay">
      <div className="amm-modal-content">
        <div className="amm-modal-header">
          <h3>Add Materials</h3>
          <button type="button" className="amm-close-btn" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="amm-modal-body">
          <div className="amm-form-grid-3">
            <div className="amm-form-group">
              <label>Name</label>
              <input 
                type="text" 
                name="name" 
                className="amm-form-control" 
                onChange={handleChange} 
              />
            </div>
            <div className="amm-form-group">
              <label>Category</label>
              <input 
                type="text" 
                name="category" 
                className="amm-form-control" 
                onChange={handleChange} 
              />
            </div>
            <div className="amm-form-group">
              <label>Rate</label>
              <input 
                type="number" 
                name="rate" 
                className="amm-form-control" 
                onChange={handleChange} 
              />
            </div>
          </div>
        </div>
        <div className="amm-modal-footer">
          <button type="button" className="amm-btn amm-btn-submit" onClick={() => onSubmit(formData)}>SUBMIT</button>
          <button type="button" className="amm-btn amm-btn-cancel" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};

export default AddMaterialModal;
